import { render } from "./_Testemonials.vue?vue&type=template&id=2dd48d24&scoped=true&lang=en"
import script from "./_Testemonials.vue?vue&type=script&lang=js"
export * from "./_Testemonials.vue?vue&type=script&lang=js"

import "./_Testemonials.vue?vue&type=style&index=0&id=2dd48d24&scoped=true&lang=scss"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd48d24"]])

export default __exports__